import React from 'react';
import { useTheme } from '../theme';
import { useAuth, useLanguage } from '../App';

/** Footer shown on all pages with dealer typical info */
export default function SiteFooter() {
  const { tokens } = useTheme();
  const { token } = useAuth();
  const { language } = useLanguage();
  let siteInfo = {};
  try { siteInfo = JSON.parse(localStorage.getItem('siteInfo') || '{}'); } catch {}
  const {
    companyName = language === 'ro' ? 'Nume firmă' : 'Company name',
    address = language === 'ro' ? 'Adresă (ex: Șos. București-Ploiești nr. ...)' : 'Address (e.g: Bucharest-Ploiesti Rd. no. ...)',
    hours = language === 'ro' ? 'Luni - Vineri: 09:00-18:00\nSâmbătă - Duminică: 10:00-14:00' : 'Monday - Friday: 09:00-18:00\nSaturday - Sunday: 10:00-14:00',
    phone = '07xx xxx xxx',
    email = 'contact@exemplu.ro',
    privacyPolicyUrl,
    termsUrl,
    anpcUrl = 'https://anpc.ro/',
    cui = 'CUI',
    regCom = 'Nr. Reg. Com',
  } = siteInfo;
  return (
    <footer style={{ marginTop: 40, background: tokens.surface, borderTop: `1px solid ${tokens.border}`, padding: '32px 24px', color: tokens.text, fontSize: 13 }}>
      <div style={{ display: 'flex', flexWrap: 'wrap', gap: 32, justifyContent: 'space-between', alignItems: 'flex-start' }}>
        <div style={{ flex: '1 1 220px', minWidth: 220 }}>
          <strong style={{ fontSize: 16 }}>{companyName}</strong>
          <div style={{ marginTop: 8 }}>{address}</div>
          <div style={{ marginTop: 8, whiteSpace: 'pre-line', lineHeight: 1.6 }}>{hours}</div>
          <div style={{ marginTop: 8 }}>Tel: {phone}</div>
          <div style={{ marginTop: 4 }}>Email: {email}</div>
        </div>
        <div style={{ flex: '1 1 180px', minWidth: 180, display: 'flex', flexDirection: 'column', gap: 6 }}>
          <strong style={{ fontSize: 16 }}>{language === 'ro' ? 'Linkuri utile' : 'Useful links'}</strong>
          {privacyPolicyUrl ? <a href={privacyPolicyUrl} style={linkStyle(tokens)} target="_blank" rel="noopener noreferrer">{language === 'ro' ? 'Politica de confidențialitate' : 'Privacy Policy'}</a> : <span style={placeholderStyle(tokens)}>{language === 'ro' ? 'Setează URL politică' : 'Set policy URL'}</span>}
          {termsUrl ? <a href={termsUrl} style={linkStyle(tokens)} target="_blank" rel="noopener noreferrer">{language === 'ro' ? 'Termeni și condiții' : 'Terms and Conditions'}</a> : <span style={placeholderStyle(tokens)}>{language === 'ro' ? 'Setează URL termeni' : 'Set terms URL'}</span>}
          <a href={anpcUrl} style={linkStyle(tokens)} target="_blank" rel="noopener noreferrer">ANPC</a>
          <a href="https://www.rarom.ro/" style={linkStyle(tokens)} target="_blank" rel="noopener noreferrer">RAR</a>
        </div>
        <div style={{ flex: '1 1 220px', minWidth: 220 }}>
          <strong style={{ fontSize: 16 }}>{language === 'ro' ? 'Informații' : 'Information'}</strong>
          <div style={{ marginTop: 8 }}>{language === 'ro' ? 'CUI' : 'Tax ID'}: {cui}</div>
          <div style={{ marginTop: 4 }}>{language === 'ro' ? 'Reg. Com' : 'Reg. No'}: {regCom}</div>
          <div style={{ marginTop: 12, opacity: 0.8 }}>© {new Date().getFullYear()} {companyName}. {language === 'ro' ? 'Toate drepturile rezervate.' : 'All rights reserved.'}</div>
        </div>
      </div>
    </footer>
  );
}

function linkStyle(tokens) {
  return { color: tokens.accent, textDecoration: 'none', fontWeight: 600 };
}
function placeholderStyle(tokens) {
  return { color: tokens.textMuted, fontStyle: 'italic' };
}
